import React from "react";

import DashboardLayout from "@/components/layout/DashboardLayout";
import { Button } from "@/components/ui/button";
import Typography from "@/components/ui/typography";
import CohortsTable from "@/features/cohorts/components/CohortsTable";
import NewCohortDrawer from "@/features/cohorts/components/NewCohortDrawer";

const Cohorts = () => {
  const [openDrawer, setOpenDrawer] = React.useState(false);

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <Typography size="h1">Cohorts</Typography>
            <Typography size="b2" className="text-muted-foreground mt-1">
              Manage all cohorts across Stack
            </Typography>
          </div>
          <Button onClick={() => setOpenDrawer(true)}>New Cohort</Button>
        </div>

        <CohortsTable />

        <NewCohortDrawer open={openDrawer} setOpen={setOpenDrawer} />
      </div>
    </DashboardLayout>
  );
};

export default Cohorts;
